export const OUTSTATION_ONE_WAY = 'Outstation One-way';
export const OUTSTATION_ROUND_TRIP = 'Outstation Round-trip';
export const RENTALS = 'Rentals';
export const OUTSTATION = 'Outstation';
export const AIRPORT = 'Airport';
export const CAB_FROM_AIRPORT = 'Cab From Airport';
export const CAB_TO_AIRPORT = 'Cab To Airport';
export const AT = 'AT';
export const C2A = 'C2A';
export const A2C = 'A2C';
export const OW = 'OW';
export const RT = 'RT';
export const HR = 'HR';

const shortCodes = {
  [OUTSTATION_ONE_WAY]: OW,
  [OUTSTATION_ROUND_TRIP]: RT,
  [RENTALS]: HR,
  [CAB_FROM_AIRPORT]: AT,
  [CAB_TO_AIRPORT]: AT
};
export const getShortCode = tripType => shortCodes[tripType];

export const isOutstationCheck = travelType => {
  return travelType == OUTSTATION_ONE_WAY || travelType == OUTSTATION_ROUND_TRIP
    ? true
    : false;
};

export const isAirportCheck = travelType => {
  return travelType == CAB_FROM_AIRPORT || travelType == CAB_TO_AIRPORT
    ? true
    : false;
};

export const getCabLandingTripTypeFromCode = shortCode => {
  switch (shortCode) {
    case A2C:
      return CAB_FROM_AIRPORT;
    case C2A:
      return CAB_TO_AIRPORT;
    case OW:
      return OUTSTATION_ONE_WAY;
    case RT:
      return OUTSTATION_ROUND_TRIP;
    case HR:
      return RENTALS;
  }
  return OUTSTATION_ONE_WAY;
};

export const getCabLandingShortCodeFromTripType = triptype => {
  switch (triptype) {
    case CAB_FROM_AIRPORT:
      return A2C;
    case CAB_TO_AIRPORT:
      return C2A;
    case RENTALS:
      return HR;
    case OUTSTATION_ROUND_TRIP:
      return RT;
    case OUTSTATION_ONE_WAY:
    default:
      return OW;
  }
};
